<template>
  <div class="form-export">
    <el-dialog v-model="dialog" @close="handleClose" :close-on-click-modal="false">
      <div id="waiting" class="center" v-if="loading"></div>
      <div class="popup-header">
        <p class="title">
          {{ title }}<br>
          {{ $t('profits.export_label') }}<br>
        </p>
      </div>
      <div class="filter">
        <div v-if="this.role == this.$userRole.admin">
          <div v-if="companies.length > 0 && type != $typeProfit.company">
            <div class="error-export error-company mt-10">{{ errors.company }}</div>
            <p class="label">{{ $t('profits.dialog_export.filter_by_company') }}</p>
            <el-select v-model="filters[2].data" :placeholder="$t('profits.dialog_export.company_filter_placeholder')"
              class="input-select" @change="handleSelectCompany(item)">
              <el-option v-for="item in companies" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </div>
        </div>
        <div v-else>
          <div v-if="type != $typeProfit.staff">
            <div class="error-export error-company mt-10">{{ errors.company }}</div>
            <p class="label">{{ $t('profits.dialog_export.filter_by_company') }}</p>
            <el-select v-model="filters[2].data" :placeholder="$t('profits.dialog_export.company_filter_placeholder')"
              class="input-select" @change="handleSelectCompany(item)">
              <el-option v-for="item in companies" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </div>
        </div>
        <div class="box-time" v-if="type == $typeProfit.staff">
          <p class="label">{{ $t('profits.dialog_export.filter_by_shop') }}</p>
          <el-select v-model="filters[3].data" :placeholder="$t('profits.dialog_export.shop_filter_placeholder')"
            class="input-select" :no-data-text="$t('no_data')">
            <el-option v-for="item in shops" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </div>
        <div class="box-time">
          <p class="label">{{ $t('profits.dialog_export.filter_by_time') }}</p>
          <date-form @change-date="changeDate" :showDayInput="false" :date="date" :listYear="listYear"></date-form>
          <div class="error-export">{{ errors.yearMonth }}</div>
        </div>
      </div>
      <div class="footer">
        <el-button type="primary" @click="exportData" class="btn btn-export">{{ $t('profits.dialog_export.btn_export')
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getAll } from '../../api/company'
import { getListShopOfCompany } from '../../api/company'
import { YEARS_START_FROM_2022 } from '../../constants'

export default {
  props: {
    openPopupExport: { type: Boolean, required: true, default: false },
    type: { type: Number, required: false },
    role: { type: Number, required: false },
    company: { type: Object, required: false, default: {} },
    site: { type: Number, required: false },
    shop: { type: Number, required: false },
  },
  emits: ['handleExportData', 'closeDialogExport'],
  data() {
    return {
      dialog: false,
      loading: false,
      date: { year: '', month: '' },
      filters: [
        { 'key': 'period_start', 'data': '' },
        { 'key': 'period_end', 'data': '' },
        { 'key': 'company_id', 'data': '' },
        { 'key': 'shop_id', 'data': '' },
      ],
      errors: {
        yearMonth: '',
        company: ''
      },
      companies: [],
      nameItemSelected: '',
      title: '',
      shops: [],
      shopName: '',
      listYear: YEARS_START_FROM_2022
    }
  },
  methods: {
    handleClose() {
      this.$emit('closeDialogExport')
    },

    exportData() {
      if (!this.date.year || !this.date.month) {
        this.errors.yearMonth = this.$t('profits.dialog_export.errors.required', [this.$t('profits.year_month')]);
      }
      if (!this.filters[2]['data'] && this.type != this.$typeProfit.company) {
        this.errors.company = this.$t('profits.dialog_export.errors.required', [this.$t('profits.company_name')]);
      }
      if (!this.errors.company && !this.errors.yearMonth) {
        if (this.type == this.$typeProfit.staff) {
          const shop = this.shops.find(item => { return item.id == this.filters[3]['data']; });
          this.nameItemSelected = shop ? shop.name : '';
        }

        this.$emit('handleExportData', this.filters, this.nameItemSelected);
      }
    },

    changeDate(data) {
      this.errors.yearMonth = '';
      this.date = data;
      const lastDayOfMonth = new Date(data.year, data.month, 0).getDate();
      this.filters[0].data = this.$dayjs(`${data.year}-${data.month}-01`).format('YYYY-MM-DD');
      this.filters[1].data = this.$dayjs(`${data.year}-${data.month}-${lastDayOfMonth}`).format('YYYY-MM-DD');
    },

    getListCompany() {
      getAll()
        .then(response => response.json())
        .then(response => {
          this.companies = response.data;
        })
        .catch((error) => { })
    },
    handleSelectCompany() {
      this.errors.company = ''
      const company = this.companies.find(item => { return item.id == this.filters[2]['data']; });
      this.nameItemSelected = company.name;
      this.filters[3].data = '';
      if (this.type == this.$typeProfit.staff) {
        getListShopOfCompany(this.filters[2].data)
          .then(response => response.json())
          .then(response => {
            this.shops = response.data;
          })
      }
    },
    getListShop() {
      getListShopOfCompany(this.filters[2].data)
        .then(response => response.json())
        .then(response => {
          this.shops = response.data;
        })
    }
  },

  created() {
    this.dialog = this.openPopupExport;
    if (this.type && this.type != this.$typeProfit.company) {
      this.getListCompany();
    }

    this.title = (this.type == this.$typeProfit.company) ? this.$t('profits.company.export.title')
      : (this.type == this.$typeProfit.shop) ? this.$t('profits.shop.export.title') : this.$t('profits.staff.export.title');

    if (this.site == this.$siteType.site_partner) {
      this.filters[2]['data'] = this.company.id;
      this.nameItemSelected = this.company.name;
    }
    if (this.type == this.$typeProfit.staff && this.site == this.$siteType.site_partner) {
      this.getListShop();
      if (this.role == this.$userRole.partner.shop) {
        const shopLogined = this.shops.filter(item => {
          return (item.id == this.shop)
        })
        this.filters[3]['data'] = this.shop;
        this.shops = this.shops.map(item => {
          return (item.id == this.shop)
        });
        this.shopName = shopLogined['name'];
      }
    }
  }
}
</script>

<style lang="scss">
.form-export {
  text-align: center !important;

  .el-dialog {
    --el-dialog-width: 760px;
    height: 689px;
    display: flex;
    justify-content: center;
    align-items: center;

    .el-dialog__header {
      padding: 0;
    }
  }

  .el-form {
    width: 100%;
    margin-bottom: 20px;
    text-align: center;

    .el-form-item {
      margin-bottom: 0;

      .el-form-item__content {
        display: block;
      }
    }
  }

  .title {
    font: normal normal normal 17px/37px Kozuka Gothic Pr6N;
    letter-spacing: 1.7px;
    color: #000000;
    font-weight: 700
  }

  .filter {
    font: normal normal normal 14px/31px Kozuka Gothic Pr6N;
    letter-spacing: 1.12px;
    color: #000000;
    margin-top: 25px;
    position: relative;

    .label {
      margin: 0 0 16px;
    }

    .box-time {
      padding-top: 30px;
    }

    .error-company {
      position: absolute;
      top: -34px;
      left: 50%;
      transform: translateX(-50%);
    }
  }

  .input-select {
    .el-input {
      width: 340px;
      height: 45px;
      --el-input-border-color: #AFA79D;
      --el-input-focus-border-color: #AFA79D;
      --el-select-input-focus-border-color: #AFA79D;
      --el-select-input-border-color: #AFA79D;
      --el-input-border-radius: 0
    }
  }

  .date-form {
    justify-content: center;

    .el-row {
      justify-content: center
    }

    .input-datetime {
      margin-left: 20px;
      width: 100% !important;

      .el-input {
        width: 90px;
        height: 45px;
        --el-select-input-focus-border-color: #c0c4cc;

        .el-input__wrapper {
          border-radius: 0;
        }
      }
    }

    .year-input {
      .input-datetime {
        margin-left: 0px;

        .el-input {
          width: 100px;
        }
      }
    }
  }

  .footer {
    margin-top: 30px;

    .btn-export {
      background: #AC3B29 0% 0% no-repeat padding-box;
      --el-button-hover-bg-color: #AC3B29;
      --el-button-hover-border-color: #AC3B29;
      --el-button-border-color: #AC3B29;
      font: normal normal normal 13px/29px Kozuka Gothic Pr6N;
      letter-spacing: 1.3px;
      color: #FFFFFF;
      width: 250px;
      height: 50px;
      border-radius: 25px !important;
    }
  }

  .error-export {
    font: normal normal normal 11px/24px Kozuka Gothic Pr6N;
    letter-spacing: 1.1px;
    color: #AC3B29;
    line-height: 15px;
  }
}
</style>
